module.exports = __webpack_public_path__ + "img/téléchargement.a9b8a04d.png";